import { graphHooks } from '@tunasong/graph-lib/react'
import { isPersisted, type GameResult } from '@tunasong/schemas'
import type { Game } from '@tunasong/schemas'
import { getLeaderBoard } from './game-dynamics.js'

export const useLeaderboard = ({ game }: { game: Game }) => {
  const { entities: gameResults = [] } = graphHooks.useEntityChildren<GameResult>({
    parentId: game.id,
    filter: 'gameresult',
    skip: !isPersisted(game),
  })

  /** @todo implement the leaderboard */
  const leaderBoard = getLeaderBoard(gameResults, 10)

  return leaderBoard
}
